import { render, staticRenderFns } from "./agoList.vue?vue&type=template&id=73cffd5c&scoped=true&"
import script from "./agoList.vue?vue&type=script&lang=js&"
export * from "./agoList.vue?vue&type=script&lang=js&"
import style0 from "./agoList.vue?vue&type=style&index=0&id=73cffd5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73cffd5c",
  null
  
)

export default component.exports